import { getRegistration } from "../serviceWorker";

export const getNotificationStatus = () => {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission;
};

export const requestNotificationPermission = async () => {
  if (getNotificationStatus() === "unsupported") return "unsupported";
  if (Notification.permission !== "default") return Notification.permission;
  return Notification.requestPermission();
};

export const showBrowserNotification = async (title, options = {}, onClick) => {
  if (getNotificationStatus() !== "granted") return undefined;
  const notificationOptions = {
    ...options,
    tag: options.tag ? String(options.tag) : undefined,
  };

  if (document.visibilityState !== "visible" && "serviceWorker" in navigator) {
    const registration = await getRegistration();
    if (registration) {
      try {
        await registration.showNotification(title, notificationOptions);
        return undefined;
      } catch (error) {
        console.warn("Não foi possível exibir a notificação pelo service worker.", error);
      }
    }
  }

  try {
    const notification = new Notification(title, notificationOptions);
    if (onClick) notification.onclick = onClick;
    return notification;
  } catch (error) {
    // Chrome para Android não oferece o construtor Notification na página.
    if ("serviceWorker" in navigator) {
      const registration = await getRegistration();
      if (registration) {
        await registration.showNotification(title, notificationOptions);
        return undefined;
      }
    }
    console.warn("Não foi possível exibir a notificação no navegador.", error);
    return undefined;
  }
};

export const showTestNotification = () =>
  showBrowserNotification("InfoChat", {
    body: "As notificações estão funcionando neste navegador.",
    icon: `${process.env.PUBLIC_URL}/android-chrome-192x192.png`,
    tag: "infochat-notification-test",
    data: { url: window.location.href },
  });
